import { ApplicationStore } from "src/store";
import { getTradeInEstimate } from "src/utils/tradePending";

export function getTradeInValue(state: ApplicationStore) {
    return (
        state.tradeIn.value?.[state.tradeIn.condition ?? "target"] ||
        state.tradeIn.customer_estimate ||
        // For backwards compatibility
        getTradeInEstimate(state.tradeIn) ||
        0
    );
}

export function getTradeInMileage(state: ApplicationStore) {
    return state.tradeIn.odometer?.amount;
}
